/**
 * Wishlist (Favoriler) JavaScript
 * Varyant bazli favori yonetimi
 * LocalStorage ile tarayicida saklama
 */

(function() {
  'use strict';

  const STORAGE_KEY = 'shopify_wishlist';

  // Wishlist Manager
  const Wishlist = {
    // LocalStorage'dan favorileri al
    getItems: function() {
      try {
        const items = localStorage.getItem(STORAGE_KEY);
        return items ? JSON.parse(items) : [];
      } catch (e) {
        console.error('Wishlist: LocalStorage okuma hatasi', e);
        return [];
      }
    },

    // LocalStorage'a kaydet
    saveItems: function(items) {
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
        this.updateAllCounts();
        this.updateAllButtons();
      } catch (e) {
        console.error('Wishlist: LocalStorage yazma hatasi', e);
      }
    },

    // Urun/varyant favorilerde mi kontrol et
    isInWishlist: function(productId, variantId) {
      const items = this.getItems();
      return items.some(function(item) {
        if (variantId && item.variantId) {
          return item.variantId === variantId;
        }
        return item.productId === productId;
      });
    },

    // Favori ekle
    addItem: function(data) {
      const items = this.getItems();

      // Zaten varsa ekleme
      const exists = items.some(function(item) {
        if (data.variantId && item.variantId) {
          return item.variantId === data.variantId;
        }
        return item.productId === data.productId;
      });

      if (!exists) {
        items.push({
          productId: data.productId,
          variantId: data.variantId || null,
          title: data.title || '',
          variantTitle: data.variantTitle || '',
          image: data.image || '',
          price: data.price || '',
          comparePrice: data.comparePrice || '',
          url: data.url || '',
          handle: data.handle || '',
          available: data.available !== false,
          addedAt: new Date().toISOString()
        });
        this.saveItems(items);
        this.showNotification('Favorilere eklendi');
        return true;
      }
      return false;
    },

    // Favori kaldir
    removeItem: function(productId, variantId) {
      let items = this.getItems();
      const initialLength = items.length;

      items = items.filter(function(item) {
        if (variantId && item.variantId) {
          return item.variantId !== variantId;
        }
        return item.productId !== productId;
      });

      if (items.length < initialLength) {
        this.saveItems(items);
        this.showNotification('Favorilerden kaldirildi');
        return true;
      }
      return false;
    },

    // Toggle favori (ekle/kaldir)
    toggleItem: function(data) {
      if (this.isInWishlist(data.productId, data.variantId)) {
        return this.removeItem(data.productId, data.variantId);
      } else {
        return this.addItem(data);
      }
    },

    // Tum favorileri temizle
    clearAll: function() {
      this.saveItems([]);
      this.showNotification('Tum favoriler temizlendi');
    },

    // Favori sayisini al
    getCount: function() {
      return this.getItems().length;
    },

    // Tum sayaclari guncelle
    updateAllCounts: function() {
      const count = this.getCount();
      const counters = document.querySelectorAll('[data-wishlist-count]');

      counters.forEach(function(counter) {
        counter.textContent = count;
        if (count > 0) {
          counter.classList.remove('hide');
        } else {
          counter.classList.add('hide');
        }
      });
    },

    // Urun sayfasindaki wishlist butonunu guncelle
    updateProductPageButton: function(variantId, variant) {
      const wishlistBtn = document.querySelector('.product-wishlist-btn[data-wishlist-add]');
      if (!wishlistBtn) return;

      wishlistBtn.setAttribute('data-variant-id', variantId);

      // Eger variant objesi varsa diger bilgileri de guncelle
      if (variant) {
        if (variant.title && variant.title !== 'Default Title') {
          wishlistBtn.setAttribute('data-variant-title', variant.title);
        }
        if (variant.price) {
          const formattedPrice = (variant.price / 100).toFixed(2).replace('.', ',') + ' TL';
          wishlistBtn.setAttribute('data-product-price', formattedPrice);
        }
        if (variant.featured_image && variant.featured_image.src) {
          wishlistBtn.setAttribute('data-product-image', variant.featured_image.src);
        }
      }

      this.updateAllButtons();
    },

    // Tum butonlari guncelle (aktif/pasif durumu)
    updateAllButtons: function() {
      const self = this;
      const buttons = document.querySelectorAll('[data-wishlist-add]');

      buttons.forEach(function(btn) {
        const productId = btn.getAttribute('data-product-id');
        const variantId = btn.getAttribute('data-variant-id');
        const textEl = btn.querySelector('[data-wishlist-btn-text]');

        if (self.isInWishlist(productId, variantId)) {
          btn.classList.add('is-active');
          btn.setAttribute('aria-pressed', 'true');
          btn.setAttribute('aria-label', 'Favorilerden Kaldır');
          if (textEl) textEl.textContent = 'Favorilerde';
        } else {
          btn.classList.remove('is-active');
          btn.setAttribute('aria-pressed', 'false');
          btn.setAttribute('aria-label', 'Favorilere Ekle');
          if (textEl) textEl.textContent = 'Favorilere Ekle';
        }
      });
    },

    // Bildirim goster
    showNotification: function(message) {
      // Mevcut bildirimi kaldir
      const existing = document.querySelector('.wishlist-notification');
      if (existing) {
        existing.remove();
      }

      // Yeni bildirim olustur
      const notification = document.createElement('div');
      notification.className = 'wishlist-notification';
      notification.innerHTML = '<span class="wishlist-notification__icon">' + this.getHeartSVG() + '</span><span class="wishlist-notification__text">' + message + '</span>';
      document.body.appendChild(notification);

      // Animasyon
      setTimeout(function() {
        notification.classList.add('is-visible');
      }, 10);

      // 3 saniye sonra kaldir
      setTimeout(function() {
        notification.classList.remove('is-visible');
        setTimeout(function() {
          notification.remove();
        }, 300);
      }, 3000);
    },

    // Heart SVG
    getHeartSVG: function() {
      return '<svg viewBox="0 0 20 20" fill="currentColor" width="16" height="16"><path d="M18.3325 7.385C18.3353 8.66729 17.8413 9.90083 16.9541 10.8267C14.92 12.9358 12.9466 15.135 10.8375 17.1667C10.3533 17.625 9.58581 17.6083 9.12331 17.1292L3.04414 10.8275C1.20664 8.9225 1.20664 5.8475 3.04414 3.94333C3.47843 3.4875 4.00075 3.1246 4.57947 2.87664C5.15818 2.62869 5.78121 2.50083 6.41081 2.50083C7.0404 2.50083 7.66344 2.62869 8.24215 2.87664C8.82086 3.1246 9.34319 3.4875 9.77747 3.94333L9.99914 4.17167L10.22 3.94333C10.6551 3.48858 11.1776 3.12635 11.7561 2.87834C12.3346 2.63033 12.9572 2.50164 13.5866 2.5C14.8533 2.5 16.0641 3.02 16.9533 3.94333C17.8408 4.86904 18.3351 6.10259 18.3325 7.385Z"/></svg>';
    },

    // Urun bilgilerini topla (butondan veya sayfadan)
    collectProductData: function(button) {
      const productId = button.getAttribute('data-product-id');
      const variantId = button.getAttribute('data-variant-id');

      // Kart icerisindeki bilgileri bul
      const card = button.closest('.grid-view-item, .product-card, [data-product-card]');
      const productPage = document.querySelector('[data-product-json]');

      let data = {
        productId: productId,
        variantId: variantId
      };

      // Urun sayfasindaysa
      if (productPage) {
        try {
          const productJson = JSON.parse(productPage.textContent);
          const selectedVariant = productJson.variants.find(function(v) {
            return v.id.toString() === variantId;
          }) || productJson.variants[0];

          data.title = productJson.title;
          data.handle = productJson.handle;
          data.variantTitle = selectedVariant.title !== 'Default Title' ? selectedVariant.title : '';
          data.image = selectedVariant.featured_image ? selectedVariant.featured_image.src : (productJson.featured_image || '');
          data.price = selectedVariant.price;
          data.comparePrice = selectedVariant.compare_at_price || '';
          data.available = selectedVariant.available;
          data.url = '/products/' + productJson.handle + (variantId ? '?variant=' + variantId : '');
        } catch (e) {
          console.error('Wishlist: Urun JSON parse hatasi', e);
        }
      }
      // Kart icerisindeyse
      else if (card) {
        const link = card.querySelector('a[href*="/products/"]');
        const image = card.querySelector('img');
        const title = card.querySelector('.product-grid--title, .grid-view-item--title, [data-product-title]');
        const price = card.querySelector('.product-price, .price, [data-product-price]');

        if (link) {
          const href = link.getAttribute('href');
          data.url = variantId ? href.split('?')[0] + '?variant=' + variantId : href;
          data.handle = href.split('/products/')[1]?.split('?')[0] || '';
        }
        if (image) {
          data.image = image.getAttribute('src') || image.getAttribute('data-src') || '';
        }
        if (title) {
          data.title = title.textContent.trim();
        }
        if (price) {
          data.price = price.textContent.trim();
        }
      }

      // Data attribute'lardan ek bilgi
      if (button.hasAttribute('data-product-title')) {
        data.title = button.getAttribute('data-product-title');
      }
      if (button.hasAttribute('data-product-image')) {
        data.image = button.getAttribute('data-product-image');
      }
      if (button.hasAttribute('data-product-price')) {
        data.price = button.getAttribute('data-product-price');
      }
      if (button.hasAttribute('data-product-url')) {
        data.url = button.getAttribute('data-product-url');
      }
      if (button.hasAttribute('data-variant-title')) {
        data.variantTitle = button.getAttribute('data-variant-title');
      }

      return data;
    },

    // Event listener'lari baslat
    init: function() {
      const self = this;

      // Sayfa yuklendiginde sayaci ve butonlari guncelle
      this.updateAllCounts();
      this.updateAllButtons();

      // Favori butonlarina click event
      document.addEventListener('click', function(e) {
        const btn = e.target.closest('[data-wishlist-add]');
        if (btn) {
          e.preventDefault();
          e.stopPropagation();

          const data = self.collectProductData(btn);
          self.toggleItem(data);
        }

        // Temizle butonu
        const clearBtn = e.target.closest('[data-wishlist-clear]');
        if (clearBtn) {
          e.preventDefault();
          if (confirm('Tum favorileri silmek istediginize emin misiniz?')) {
            self.clearAll();
            self.renderWishlistPage();
          }
        }

        // Tek urun silme (favoriler sayfasinda)
        const removeBtn = e.target.closest('[data-wishlist-remove]');
        if (removeBtn) {
          e.preventDefault();
          const productId = removeBtn.getAttribute('data-product-id');
          const variantId = removeBtn.getAttribute('data-variant-id');
          self.removeItem(productId, variantId);
          self.renderWishlistPage();
        }
      });

      // Urun sayfasinda varyant degistiginde buton guncelle
      document.addEventListener('change', function(e) {
        if (e.target.matches('input[name="id"], select[name="id"]')) {
          const newVariantId = e.target.value;
          self.updateProductPageButton(newVariantId);
        }
      });

      // Variant değişikliğini dinle (custom event)
      document.addEventListener('variant:change', function(e) {
        if (e.detail && e.detail.variant) {
          const variant = e.detail.variant;
          self.updateProductPageButton(variant.id, variant);
        }
      });

      // Favoriler sayfasini renderla
      this.renderWishlistPage();
    },

    // Favoriler sayfasini renderla
    renderWishlistPage: function() {
      const self = this;
      const container = document.querySelector('[data-wishlist-container]');
      if (!container) return;

      const items = this.getItems();
      const emptyStateLogin = document.querySelector('[data-wishlist-empty-login]');
      const emptyStateNoItems = document.querySelector('[data-wishlist-empty]');
      const countEl = document.querySelector('[data-wishlist-page-count]');
      const countWrapper = document.querySelector('[data-wishlist-count-wrapper]');
      const actionsWrapper = document.querySelector('[data-wishlist-actions]');

      // Musteri giris yapmis mi kontrol et
      const pageWrapper = document.querySelector('[data-wishlist-page]');
      const isLoggedIn = pageWrapper ? pageWrapper.getAttribute('data-customer-logged-in') === 'true' : false;
      const headerWrapper = document.querySelector('[data-wishlist-header]');

      if (countEl) {
        countEl.textContent = items.length;
      }

      if (items.length === 0) {
        container.innerHTML = '';

        // Sayac ve aksiyonlari gizle
        if (countWrapper) countWrapper.classList.add('hide');
        if (actionsWrapper) actionsWrapper.classList.add('hide');

        // Giris durumuna gore mesaj goster
        if (!isLoggedIn && emptyStateLogin) {
          emptyStateLogin.classList.remove('hide');
          if (emptyStateNoItems) emptyStateNoItems.classList.add('hide');
        } else if (emptyStateNoItems) {
          emptyStateNoItems.classList.remove('hide');
          if (emptyStateLogin) emptyStateLogin.classList.add('hide');
        }
        return;
      }

      // Urunler varsa bos durumlari gizle
      if (emptyStateLogin) emptyStateLogin.classList.add('hide');
      if (emptyStateNoItems) emptyStateNoItems.classList.add('hide');
      if (countWrapper) countWrapper.classList.remove('hide');
      if (actionsWrapper) actionsWrapper.classList.remove('hide');

      // Urun kartlarini renderla (API kullanmadan, LocalStorage verileriyle)
      let html = '<div class="grid-uniform grid--collection">';

      items.forEach(function(item) {
        html += self.renderProductCard(item);
      });

      html += '</div>';
      container.innerHTML = html;

      // Butonlari guncelle
      self.updateAllButtons();
    },

    // Urun karti renderla (grid-view-item benzeri, LocalStorage verisiyle)
    renderProductCard: function(item) {
      const imageUrl = item.image || '';
      const productUrl = item.url || '#';
      const price = item.price || '';
      const variantTitle = item.variantTitle || '';

      let html = '';
      html += '<div class="grid__item grid-view-item small--one-half medium--one-third large--one-quarter">';
      html += '<div class="grid-view-item-image" style="position:relative;">';

      // Favori butonu (kaldir icin)
      html += '<button type="button" class="wishlist-btn is-active" data-wishlist-add data-product-id="' + item.productId + '" data-variant-id="' + (item.variantId || '') + '" aria-label="Favorilerden kaldır" aria-pressed="true">';
      html += '<svg viewBox="0 0 20 20" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M18.3325 7.385C18.3353 8.66729 17.8413 9.90083 16.9541 10.8267C14.92 12.9358 12.9466 15.135 10.8375 17.1667C10.3533 17.625 9.58581 17.6083 9.12331 17.1292L3.04414 10.8275C1.20664 8.9225 1.20664 5.8475 3.04414 3.94333C3.47843 3.4875 4.00075 3.1246 4.57947 2.87664C5.15818 2.62869 5.78121 2.50083 6.41081 2.50083C7.0404 2.50083 7.66344 2.62869 8.24215 2.87664C8.82086 3.1246 9.34319 3.4875 9.77747 3.94333L9.99914 4.17167L10.22 3.94333C10.6551 3.48858 11.1776 3.12635 11.7561 2.87834C12.3346 2.63033 12.9572 2.50164 13.5866 2.5C14.8533 2.5 16.0641 3.02 16.9533 3.94333C17.8408 4.86904 18.3351 6.10259 18.3325 7.385Z" stroke-linejoin="round"/></svg>';
      html += '</button>';

      // Urun resmi
      html += '<a href="' + productUrl + '" class="grid__image" tabindex="-1">';
      if (imageUrl) {
        html += '<img src="' + imageUrl + '" alt="' + (item.title || '') + '" loading="lazy" class="theme-img block-radius">';
      } else {
        html += '<div class="placeholder-image" style="background:#f5f5f5;padding-top:100%;"></div>';
      }
      html += '</a>';
      html += '</div>'; // grid-view-item-image

      // Urun bilgileri
      html += '<div class="grid-view-item--info">';
      html += '<a href="' + productUrl + '" class="grid-view-item--title product-grid--title">' + (item.title || 'Ürün') + '</a>';

      if (variantTitle && variantTitle !== 'Default Title') {
        html += '<p class="grid-view-item--variant" style="font-size:12px;color:#666;margin:4px 0;">' + variantTitle + '</p>';
      }

      if (price) {
        html += '<div class="grid-view-item--price product-grid--price">';
        html += '<span class="product-price--current">' + price + '</span>';
        html += '</div>';
      }

      html += '</div>'; // grid-view-item--info
      html += '</div>'; // grid__item

      return html;
    },

    // Fiyat formatlama
    formatPrice: function(price) {
      if (!price) return '';
      // Eger zaten formatli ise
      if (typeof price === 'string' && (price.includes('TL') || price.includes('₺'))) {
        return price;
      }
      // Sayisal deger ise formatla
      const numPrice = parseFloat(price) / 100;
      return numPrice.toLocaleString('tr-TR', { style: 'currency', currency: 'TRY' });
    }
  };

  // Sayfa yuklendiginde baslat
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      Wishlist.init();
    });
  } else {
    Wishlist.init();
  }

  // Global erisim icin
  window.Wishlist = Wishlist;

})();
